import { render, staticRenderFns } from "./AdminCustomerInvoiceFilters.vue?vue&type=template&id=55d52798"
import script from "./AdminCustomerInvoiceFilters.vue?vue&type=script&lang=js"
export * from "./AdminCustomerInvoiceFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports